"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const ticket_1 = require("@pbl/pbl-react-core/lib/models/ticket");
const types_1 = require("@pbl/pbl-react-core/lib/models/ticket/types");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const JsonUtils_1 = require("../utils/JsonUtils");
const DigitalRevealGame_1 = require("./DigitalRevealGame");
const TicketScreenStyle_1 = require("./jss/TicketScreenStyle");
const DigitalRevealSummaryModal_1 = require("./ticket-entry-sections/digital-reveal/DigitalRevealSummaryModal");
const OptOutConfirmationDialog_1 = require("./ticket-entry-sections/second-chance/OptOutConfirmationDialog");
const TicketDialog_1 = require("./TicketDialog");
const initialState = {
    optOutPrizes: {},
    optOutList: [],
    show: false,
    showDigitalRevealSummary: false,
    showDigitalRevealGame: false,
    gameCompleted: false,
    showConfirmationModal: false,
    selectedSecondChanceEntry: {},
    setSelection: undefined
};
class TicketValidatedModal extends React.Component {
    constructor() {
        super(...arguments);
        this.state = Object.assign({}, initialState);
        this.onOptOutConfirmationDialog = (selection, args, optOutItem, setSelection) => {
            this.setState({
                selectedSecondChanceEntry: optOutItem,
                setSelection,
                showConfirmationModal: true
            });
        };
        this.onChecked = (entry, previousValue, value) => {
            if (!entry || !entry.id || !entry.draw || !entry.draw.id || !entry.draw.name)
                return;
            const optOut = previousValue === value ? !!previousValue : !!value;
            this.setState({
                optOutPrizes: Object.assign(Object.assign({}, this.state.optOutPrizes), { [entry.id]: {
                        preference: {
                            prizeId: entry.id,
                            drawId: entry.draw.id,
                            optOut
                        },
                        drawName: entry.draw.name,
                        entries: entry.amount,
                        optInMessage: entry.draw.optInMessage,
                        optOutMessage: entry.draw.optOutMessage
                    } })
            });
        };
        this.onOk = () => {
            this.setState(Object.assign({}, initialState), () => {
                this.props.onDismiss();
            });
        };
        this.onSkipGamePlay = async () => {
            var _a, _b;
            const { prizes, startGame, skipGame } = this.props;
            if (!!prizes && !!skipGame && !!startGame) {
                const digitalReveal = this.getDigitalRevealToken();
                if (digitalReveal && digitalReveal.length > 0 && !!digitalReveal[0].token) {
                    startGame((_a = digitalReveal[0].token) === null || _a === void 0 ? void 0 : _a.key);
                    skipGame((_b = digitalReveal[0].token) === null || _b === void 0 ? void 0 : _b.key);
                }
            }
            this.setState({ showDigitalRevealSummary: true });
        };
        this.onPlay = () => {
            this.setState({ showDigitalRevealGame: true });
        };
        this.onConfirmOk = () => {
            this.state.setSelection(!this.state.selectedSecondChanceEntry.preference.optOut);
            if (this.props.onOptOut) {
                this.props.onOptOut(this.state.selectedSecondChanceEntry.preference);
            }
            this.setState({
                showConfirmationModal: false
            });
        };
        this.getFilterPrizes = (prizes, prizeType, criteria) => prizes
            .filter((x) => x.prizeType === prizeType && (criteria ? !!x.token : !x.token))
            .reduce((total, p) => total + (p.amount || 0), 0);
        this.onConfirmGoBack = () => {
            this.setState({
                showConfirmationModal: false
            });
        };
        this.getGameData = () => {
            var _a;
            const { prizes } = this.props;
            if (!!prizes && !!this.props.getGameData) {
                const digitalReveal = this.getDigitalRevealToken();
                if (digitalReveal && digitalReveal.length > 0 && !!digitalReveal[0].token) {
                    this.props.getGameData((_a = digitalReveal[0].token) === null || _a === void 0 ? void 0 : _a.key);
                }
            }
        };
        this.gameCompleted = () => {
            this.setState({ gameCompleted: true });
        };
        this.gameClosed = () => {
            this.setState(Object.assign({}, initialState), () => {
                this.props.onDismiss();
            });
        };
        this.gameEnded = () => {
            var _a;
            const { prizes } = this.props;
            if (!!prizes && !!this.props.endGame) {
                this.setState({ showDigitalRevealGame: false, gameCompleted: true });
                const digitalReveal = this.getDigitalRevealToken();
                if (digitalReveal && digitalReveal.length > 0 && !!digitalReveal[0].token) {
                    this.props.endGame((_a = digitalReveal[0].token) === null || _a === void 0 ? void 0 : _a.key);
                    if (this.props.showDigitalRevealSummaryOnEnd) {
                        this.setState({ showDigitalRevealSummary: true });
                    }
                    else {
                        this.onOk();
                    }
                }
            }
        };
        this.getDigitalGameInfo = (digitalReveal, prizes) => {
            var _a, _b, _c;
            let gameUrl;
            let gameVendor = 'PBL';
            let gameConfig;
            const prizeLevelBreakDownObj = digitalReveal[0].prizeLevelBreakdown;
            const face = (0, JsonUtils_1.parseJson)((_a = digitalReveal[0].token) === null || _a === void 0 ? void 0 : _a.face);
            const configObj = (_b = digitalReveal[0].token) === null || _b === void 0 ? void 0 : _b.gameConfig;
            if (configObj) {
                const basePoints = this.getFilterPrizes(prizes, types_1.PrizeType.LOYALTY_POINTS, false);
                const baseEntries = this.getFilterPrizes(prizes, types_1.PrizeType.ENTRY, false);
                const bonusPoints = this.getFilterPrizes(prizes, types_1.PrizeType.LOYALTY_POINTS, true);
                const bonusEntries = this.getFilterPrizes(prizes, types_1.PrizeType.ENTRY, true);
                const _gameConfig = (0, JsonUtils_1.parseJson)(configObj);
                gameConfig = _gameConfig
                    ? Object.assign(Object.assign({}, _gameConfig), { baseEntries, basePoints, bonusPoints, bonusEntries }) : undefined;
                gameVendor = !!gameConfig.vendor ? gameConfig.vendor : 'PBL';
                const themeUrl = (_c = digitalReveal[0].token) === null || _c === void 0 ? void 0 : _c.themeHostName;
                const pblGameUrl = !!gameConfig.gameUrl ? gameConfig.gameUrl : themeUrl;
                gameUrl = gameVendor === 'SGI' ? themeUrl : pblGameUrl;
            }
            return { gameConfig, face, prizeLevelBreakDownObj, gameUrl, gameVendor };
        };
        this.getDigitalRevealToken = () => {
            const { prizes } = this.props;
            return prizes.filter((x) => !!x.token);
        };
    }
    async componentDidUpdate(prevProps, prevState) {
        if (prevProps.optOutPreferences !== this.props.optOutPreferences) {
            const { optOutPreferences, prizes } = this.props;
            if (optOutPreferences) {
                const entries = prizes.filter((x) => x.prizeType === types_1.PrizeType.ENTRY);
                if (entries && entries.length > 0) {
                    const unchangedPreferences = optOutPreferences === null || optOutPreferences === void 0 ? void 0 : optOutPreferences.map(pref => {
                        const entry = entries.find(e => { var _a; return pref.drawId === ((_a = e.draw) === null || _a === void 0 ? void 0 : _a.id); });
                        return Object.assign(Object.assign({}, pref), { prizeId: entry === null || entry === void 0 ? void 0 : entry.id });
                    });
                    if (this.props.onOptOut) {
                        this.props.onOptOut(unchangedPreferences);
                    }
                }
            }
        }
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g;
        const { showSuccessModal, prizes, graphicImageUrl, showTicketDisclaimer, navigateToSuperBonusDetails, displayConfetti } = this.props;
        const digitalReveal = prizes.filter((x) => !!x.token);
        let digitalGameObj;
        if (Boolean(!!digitalReveal &&
            digitalReveal.length > 0 &&
            (((_a = digitalReveal[0].token) === null || _a === void 0 ? void 0 : _a.gameConfig) || ((_b = digitalReveal[0].token) === null || _b === void 0 ? void 0 : _b.themeHostName)) &&
            ((_c = digitalReveal[0].token) === null || _c === void 0 ? void 0 : _c.face))) {
            digitalGameObj = this.getDigitalGameInfo(digitalReveal, prizes);
        }
        const entryPrizes = digitalReveal.filter((prize) => prize.prizeType === types_1.PrizeType.ENTRY);
        const digitalRevealItems = entryPrizes.length > 0
            ? ticket_1.TicketSubmissionPrizeDTOList.TicketSubmissionPrizeDTOArrayToTicketSubmissionPrizeDTOList(prizes).getEntries(true)
            : prizes.filter(entry => !!entry.token);
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(TicketDialog_1.default, { showSuccessModal: showSuccessModal, prizes: prizes, graphicImageUrl: graphicImageUrl, optOutPreferences: this.props.optOutPreferences, optOutPrizes: this.state.optOutPrizes, gameConfig: digitalGameObj === null || digitalGameObj === void 0 ? void 0 : digitalGameObj.gameConfig, onOk: this.onOk, onPlay: this.onPlay, onChecked: this.onChecked, onSkipGamePlay: this.onSkipGamePlay, onOpenDrawDetails: this.props.onOpenDrawDetails, showTicketDisclaimer: showTicketDisclaimer, navigateToSuperBonusDetails: navigateToSuperBonusDetails, displayConfetti: displayConfetti, onOptOutConfirmationDialog: this.onOptOutConfirmationDialog }), !!this.state.showConfirmationModal && ((0, jsx_runtime_1.jsx)(OptOutConfirmationDialog_1.default, { onOk: this.onConfirmOk, onGoBack: this.onConfirmGoBack, currentConfirmItem: this.state.selectedSecondChanceEntry })), (0, jsx_runtime_1.jsx)(DigitalRevealSummaryModal_1.default, { visible: this.state.showDigitalRevealSummary, onOk: this.onOk, digitalRevealItems: digitalRevealItems, prizes: prizes }), (0, jsx_runtime_1.jsx)(DigitalRevealGame_1.default, { visible: this.state.showDigitalRevealGame, gameUrl: digitalGameObj === null || digitalGameObj === void 0 ? void 0 : digitalGameObj.gameUrl, gamePoints: !!((_d = digitalGameObj === null || digitalGameObj === void 0 ? void 0 : digitalGameObj.face) === null || _d === void 0 ? void 0 : _d.points) ? Number(digitalGameObj.face.points) : 10, gameEntries: !!((_e = digitalGameObj === null || digitalGameObj === void 0 ? void 0 : digitalGameObj.face) === null || _e === void 0 ? void 0 : _e.entries) ? Number(digitalGameObj.face.entries) : 10, ticketPrice: !!((_f = digitalGameObj === null || digitalGameObj === void 0 ? void 0 : digitalGameObj.gameConfig) === null || _f === void 0 ? void 0 : _f.ticketPrice) ? digitalGameObj.gameConfig.ticketPrice : 1, multiplier: !!(digitalGameObj === null || digitalGameObj === void 0 ? void 0 : digitalGameObj.prizeLevelBreakDownObj)
                        ? digitalGameObj.prizeLevelBreakDownObj.baseMultiplier
                        : 1, portraitMode: true, gameFace: digitalGameObj === null || digitalGameObj === void 0 ? void 0 : digitalGameObj.face, gameConfig: digitalGameObj === null || digitalGameObj === void 0 ? void 0 : digitalGameObj.gameConfig, drawNumber: !!digitalRevealItems && digitalRevealItems.length > 0
                        ? (_g = digitalRevealItems[0].draw) === null || _g === void 0 ? void 0 : _g.drawNumber
                        : undefined, getGameData: this.getGameData, onGameExitHandler: this.gameEnded, onGameEndHandler: this.gameCompleted, onGameCloseHandler: this.gameClosed, vendor: (digitalGameObj === null || digitalGameObj === void 0 ? void 0 : digitalGameObj.gameVendor) === 'SGI' ? 'SGI' : 'PBL' })] }));
    }
}
exports.default = (0, core_1.withStyles)(TicketScreenStyle_1.default)((0, react_i18next_1.withTranslation)()(TicketValidatedModal));
//# sourceMappingURL=TicketValidatedModal.js.map